var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-data-table", {
    staticClass: "has-border",
    attrs: {
      loading: _vm.loading,
      "disable-sort": "",
      headers: _vm.headers,
      page: _vm.currentPage,
      items: _vm.items,
      "server-items-length": _vm.count,
    },
    on: {
      "update:page": function ($event) {
        _vm.currentPage = $event
      },
      "update:options": (pagination) => _vm.onPageChange(pagination),
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function (props) {
          return [
            _c("tr", [
              _c(
                "td",
                [
                  _c("BaseTitleTable", [
                    _vm._v(
                      _vm._s(
                        props.item.student && props.item.student.name
                          ? props.item.student.name
                          : _vm.$vuetify.lang.t("$vuetify.TEXT_NOT_NAME")
                      )
                    ),
                  ]),
                ],
                1
              ),
              _c("td", [
                _vm._v(
                  _vm._s(_vm.dayjs(props.item.createdAt).format("DD/MM/YYYY"))
                ),
              ]),
              _c("td", [_vm._v(_vm._s(_vm.generateDiscountTitle(props.item)))]),
              _c("td", [
                _vm._v(
                  " " +
                    _vm._s(
                      `${
                        props.item.isUseAffiliate
                          ? _vm.$vuetify.lang.t("$vuetify.TEXT_YES")
                          : _vm.$vuetify.lang.t("$vuetify.TEXT_NO")
                      }`
                    ) +
                    " "
                ),
              ]),
              _c("td", [
                _vm._v(
                  " " +
                    _vm._s(
                      `${(
                        props.item.rootPrice || 0
                      ).toLocaleString()}${_vm.$vuetify.lang.t(
                        "$vuetify.USER_MANAGE.TEACHER_SALE.TEXT_CURRENT_UNIT"
                      )}`
                    ) +
                    " "
                ),
              ]),
              _c("td", [
                _vm._v(
                  " " +
                    _vm._s(
                      `${props.item.price.toLocaleString()}${_vm.$vuetify.lang.t(
                        "$vuetify.USER_MANAGE.TEACHER_SALE.TEXT_CURRENT_UNIT"
                      )}`
                    ) +
                    " "
                ),
              ]),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }